import {initializeApp} from 'firebase/app';
import {getStorage} from 'firebase/storage';
import {getMessaging} from "firebase/messaging"
import {browserLocalPersistence, browserPopupRedirectResolver, initializeAuth} from "firebase/auth";
import {supportsFCM} from "./utils/messaging";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const storage = getStorage(app)

export const messaging = supportsFCM() ? getMessaging(app) : null

/**
 * Persistence is declared once, at initialization. Calling setPersistence on every page load
 * re-saved the signed-in user each time, which other open tabs saw as a sign-out — and they
 * then deleted the shared session cookie. The saved sign-in already lives in localStorage, so
 * nothing moves. initializeAuth (unlike getAuth) needs the popup resolver for social sign-in.
 */
export const auth = initializeAuth(app, {
    persistence: browserLocalPersistence,
    popupRedirectResolver: browserPopupRedirectResolver
})
